module.exports = __webpack_public_path__ + "static/media/icon-campaing.6df6a1e1.svg";